"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (params) {

    params = params || {};

    var self = {};

    self.destroy = function () {

        if (autocompleteFreshRequestFilter !== null) {
            autocompleteFreshRequestFilter.cancel();
            autocompleteFreshRequestFilter = null;
        }

        if (geocodeFreshRequestFilter !== null) {
            geocodeFreshRequestFilter.cancel();
            geocodeFreshRequestFilter = null;
        }
    };

    var autocompleteFreshRequestFilter = new _FreshRequestFilter2.default();
    var geocodeFreshRequestFilter = new _FreshRequestFilter2.default();

    // On change of the google search input field (auto complete)
    self.getSuggestions = function (params) {

        var value = params.value;
        var countryCode = params.countryCode;
        var baseLatLng = params.baseLatLng || null;
        var onSuggestions = params.onSuggestions;
        var types = params.types || ["geocode"];
        var filterTypes = params.filterTypes || null;

        // Clean ups before we start...
        geocodeFreshRequestFilter.cancel();

        // If no value given, suggest nothing
        if (!value) {
            onSuggestions([]);
            return;
        }

        // Perform the actual request
        var autocompleteRequest = { types: types, componentRestrictions: { country: countryCode }, input: value };

        if (baseLatLng !== null) {
            autocompleteRequest.location = baseLatLng;
            autocompleteRequest.radius = 1000 * 50;
        }

        _GmapsService2.default.autocomplete({
            request: autocompleteRequest,
            callback: autocompleteFreshRequestFilter.getCallback(function (response) {

                // Error during request
                if (response.error) {
                    // Nothing to do
                    onSuggestions([]);
                    return;
                }

                // Result received, show suggestions

                var results = response.value;
                if (filterTypes) {
                    results = _lodash2.default.filter(results, function (pred) {
                        return _lodash2.default.includes(pred.types, filterTypes);
                    });
                }

                onSuggestions(results);
            })
        });
    };

    self.locate = function (params) {
        var formatted = params.formatted;
        var placeId = params.placeId;
        var allowInexact = params.allowInexact || false;
        var countryCode = params.countryCode;
        var googleLanguage = params.googleLanguage;
        var location = params.location;
        var onSuccess = params.onSuccess;
        var onNotFound = params.onNotFound;
        var onError = params.onError;

        // If no value given, do nothing
        if (!location && !formatted) {
            onNotFound();
            return;
        }

        // Clean up
        autocompleteFreshRequestFilter.cancel();

        var request = {
            region: countryCode
        };

        if (location) {
            request = {
                location: location
            };
        } else if (placeId) {
            request.placeId = placeId;
        } else {
            request.address = formatted;
        }

        _GmapsService2.default.geocode({
            request: request,
            callback: geocodeFreshRequestFilter.getCallback(function (response) {

                // Network error?
                if (response.error) {
                    onError();
                    return;
                }

                var results = response.value;

                // Not found?
                if (results.length === 0) {
                    onNotFound();
                    return;
                }

                var result = (placeId ? _lodash2.default.find(results, { place_id: placeId }) : null) || results[0];

                if (!result.geometry || !result.geometry.location) {
                    onNotFound();
                    return;
                }

                var isExact = _lodash2.default.includes(result.types, 'street_address') || _lodash2.default.includes(result.types, 'premise') || result.geometry.location_type === 'ROOFTOP';

                if (!allowInexact && !isExact) {
                    onNotFound();
                    return;
                }

                var address = _lodash2.default.extend({}, { formatted: formatted }, geocode2address(result));

                if (googleLanguage) {
                    _LocalizedGmapsService2.default.translateFormat({
                        language: googleLanguage, format: address.formatted,
                        callback: function callback(formatted) {
                            address.formatted = formatted;
                            onSuccess(address);
                        }
                    });
                } else {
                    onSuccess(address);
                }
            })
        });
    };

    function geocode2address(geocode) {
        var address = {
            formatted: geocode.formatted_address || null,
            latLng: geocode.geometry.location || null,
            approximate: !_lodash2.default.includes(geocode.types, "street_address") && !_lodash2.default.includes(geocode.types, "premise") && geocode.geometry.location_type !== 'ROOFTOP'
        };

        _lodash2.default.each(geocode.address_components, function (component) {
            _lodash2.default.each(component.types, function (type) {
                switch (type) {
                    case "country":
                        address.country = component.long_name || null;
                        address.countryCode = component.short_name || null;
                        break;
                    case "locality":
                        address.city = component.long_name || null;
                        break;
                    case "route":
                        address.street = component.long_name || null;
                        break;
                    case "street_number":
                        address.number = component.long_name || null;
                        break;
                    case "postal_code":
                        address.postalCode = component.long_name || null;
                        break;
                    default:
                        // Do nothing
                        break;
                }
            });
        });

        return address;
    }
    self.geocode2address = geocode2address;

    return self;
};

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _FreshRequestFilter = require("./FreshRequestFilter.js");

var _FreshRequestFilter2 = _interopRequireDefault(_FreshRequestFilter);

var _GmapsService = require("./GmapsService.js");

var _GmapsService2 = _interopRequireDefault(_GmapsService);

var _LocalizedGmapsService = require("./LocalizedGmapsService.js");

var _LocalizedGmapsService2 = _interopRequireDefault(_LocalizedGmapsService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }